import React, { useCallback, useEffect } from 'react';

// Image-only lightbox: prev/next cycle within the collection; close via the
// button, the scrim or Esc.
const PhotoViewer = ({
  items,
  index,
  onIndex,
  onClose,
  isPhone
}) => {
  const open = index !== null && index >= 0 && items.length > 0;
  const step = useCallback(delta => onIndex((index + delta + items.length) % items.length), [index, items.length, onIndex]);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose, step]);
  if (!open) return null;
  return React.createElement("div", {
    className: "cp-lbscrim",
    onClick: onClose
  }, React.createElement("div", {
    className: "cp-lbmodal",
    onClick: e => e.stopPropagation()
  }, React.createElement("div", {
    className: "cp-lbmedia"
  },
  // The modal takes the photo's shape rather than a fixed box: a portrait
  // reference is not a landscape one with the sides cut off.
  React.createElement("img", {
    className: `cp-lbimg${isPhone ? ' is-phone' : ''}`,
    src: items[index].url,
    alt: "",
    draggable: false
  }), React.createElement("button", {
    type: "button",
    className: "cp-lbclose",
    onClick: onClose,
    "aria-label": "Close"
  }, React.createElement("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round"
  }, React.createElement("path", {
    d: "M18 6L6 18M6 6l12 12"
  }))), React.createElement("button", {
    type: "button",
    className: "cp-lbprev",
    onClick: e => {
      e.stopPropagation();
      step(-1);
    },
    "aria-label": "Previous photo"
  }, React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M15 18l-6-6 6-6"
  }))), React.createElement("button", {
    type: "button",
    className: "cp-lbnext",
    onClick: e => {
      e.stopPropagation();
      step(1);
    },
    "aria-label": "Next photo"
  }, React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M9 6l6 6-6 6"
  }))))));
};
export default PhotoViewer;
